import React from 'react'
import { MatchLoader } from 'loaders'
import PropTypes from 'prop-types'
import MatchDashboardContainer from '../../components/MatchDashboard/MatchDashboardContainer'

const MatchDashboard = ({
  match: {
    params: { matchId },
  },
}) => (
  <MatchLoader matchId={matchId}>
    <MatchDashboardContainer matchId={matchId} />
  </MatchLoader>
)

MatchDashboard.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      matchId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default MatchDashboard
